// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"66236510","609":"796f3f0d"}[chunkId] + ".chunk.js";
};